import { Component, DestroyRef, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Filter, Product } from '@scalefast/core';

// Scalefast components
import { SearchBarService } from '@scalefast/ecommerce-core';
import { asapScheduler } from 'rxjs';
import { GenericEventService } from '../../../../../shared/services';
import { AppSearchBarTemplateComponent } from '../search-bar-template/search-bar-template.component';

@Component({
  selector: 'app-search-bar',
  template: `<app-search-bar-template
    [isActiveSearch]="isActiveSearch"
    [searchResults]="searchResults"
    (searchFormChange)="onSearchFormChange($event)"
    (resetFilters)="resetSearchFilters()"
    (goToSearchResultsPage)="showSearchResultsPage($event)"
  />`,
  standalone: true,
  imports: [AppSearchBarTemplateComponent],
})
export class AppSearchBarComponent {
  @ViewChild(AppSearchBarTemplateComponent) searchBarComponent!: AppSearchBarTemplateComponent;
  isActiveSearch = false;
  isMobile = true;
  filter: Filter;
  searchResults: Product[] = [];

  constructor(
    private searchBarService: SearchBarService,
    private destroyRef: DestroyRef,
    private genericEventService: GenericEventService,
  ) {
    this.filter = this.searchBarService.getFilter();
    this.searchBarService.searchBarEvents$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: Record<string, Product[]>) => {
        this.searchResults = data.products;
        this.filter = this.searchBarService.getFilter();
        this.isActiveSearch = true;
      });
  }

  onSearchFormChange(keyword: string) {
    this.searchBarService.pushSearchBarEvent(keyword);
  }

  resetSearchFilters(): void {
    this.searchBarService.setFilter('search', [], '');
    this.filter = this.searchBarService.getFilter();
    this.isActiveSearch = false;
    this.searchResults = [];
  }

  triggerOpenSearchBarMobileContainer(): void {
    asapScheduler.schedule(() => {
      this.isMobile = !this.isMobile;
    }, 1000);
  }

  showSearchResultsPage(searchCriteria: string): void {
    this.searchBarService.navigateToSearchPage(searchCriteria);
    this.resetSearchFilters();
    this.clickSearchProduct();
  }

  clickSearchProduct(): void {
    this.genericEventService.emitSearchProductClick();
  }

  focusInput() {
    this.searchBarComponent.focusInput();
  }

  cleanSearch() {
    this.searchBarComponent.cleanInput();
  }
}
